/** Minimal brand-agnostic selectable list item: a `<button>` with caller-supplied style, an `isSelected`-derived aria attribute and an `onSelect` callback. */

import { BUTTON_TYPE } from '../common/aria-tokens.ts';
import type { JSX } from 'react';
import type { SelectableButtonProps } from '@federa/types/ui-button';

export function SelectableButton(props: SelectableButtonProps): JSX.Element {
	const { isSelected, onSelect, style, children, selectionAria, role, className, hoverHandlers } = props;
	const ariaProps = selectionAria === 'selected' ? { 'aria-selected': isSelected } : { 'aria-pressed': isSelected };
	return (
		<button
			type={BUTTON_TYPE.button}
			onClick={onSelect}
			className={className}
			role={role}
			style={style}
			{...ariaProps}
			onMouseEnter={hoverHandlers?.onMouseEnter}
			onMouseLeave={hoverHandlers?.onMouseLeave}
		>
			{children}
		</button>
	);
}
